import type { SearchBannerData } from '@/types';
import * as Styled from './SearchBanner.styled';

interface SearchBannerProps {
  banner?: SearchBannerData;
}

/**
 * Renders the Algolia out-of-the-box search banner (from a Query Rule's banner
 * consequence, surfaced by useInfiniteHits().banner). Presentational only;
 * renders nothing when no banner / image is present.
 */
export const SearchBanner = ({ banner }: SearchBannerProps) => {
  const imageUrl = banner?.image?.urls?.[0]?.url;

  if (!imageUrl) {
    return null;
  }

  const image = (
    <Styled.BannerImage
      alt={banner.image.title ?? ''}
      loading="eager"
      src={imageUrl}
    />
  );

  if (!banner.link?.url) {
    return <Styled.BannerWrapper>{image}</Styled.BannerWrapper>;
  }

  const isExternal = banner.link.target === '_blank';

  return (
    <Styled.BannerWrapper>
      <Styled.BannerLink
        href={banner.link.url}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        target={banner.link.target ?? '_self'}
      >
        {image}
      </Styled.BannerLink>
    </Styled.BannerWrapper>
  );
};
